import styled from "styled-components"

export const Logo = styled.img`
  max-width: 60px;
  margin-bottom: 32px;
  border-radius: 4px;
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding-top: 25vh;
  height: 85vh;
  transition: 0.4s;
  flex-direction: column;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 123456789;
  background-color: #fff;
`

export const Loading = styled.div`
  height: 4px;
  width: 182px;
  background-color: #dbe1e2;
  overflow: hidden;
  position: relative;

  @keyframes initial-loading {
    0% {
      transform: translate(-24px);
    }

    50% {
      transform: translate(158px);
    }

    to {
      transform: translate(-24px);
    }
  }

  div {
    height: 100%;
    width: 48px;
    position: absolute;
    transform: translate(-x);
    background-color: #0446ca;
    border-radius: 2px;
    animation: initial-loading 1.5s ease infinite;
  }
`
